<template>
  <div class="model">
    <div id="pocked"></div>
  </div>
</template>

<script>
import { PackedChart } from "@/minix.js";
import _ from "lodash";
export default {
  props: ["equip_data","breakdown_point","measurements_list"],
  data() {
    return {
      breakList:{
        "电机超功率":[{name:'运行电流',value:'35.7',status:2},{name:'实际转速',value:'682',status:1}],
        "轴承温度":[{name:'驱动端轴承温度',value:'40.1',status:1},{name:'实际转速',value:'682',status:1}],
        "振动噪音":[ {name:'非驱动端轴承振动',value:'2.3',status:2}, {name:'驱动端轴承振动',value:'2.2',status:1},{name:'工作液入口温度',value:'35.6',status:"error",unit:'℃'}],
        "卡泵低风险预警":[{name:'电机扭矩',value:'29',status:1}],
        "电机绕阻温度高":[ {name:'出口孔板',value:'74.1',status:1}],
        "鼓风机喘振低风险预警":[ {name:'运行转速',value:'16310',status:1}]
      },
      dataName:[
        [
          {name:'实际转速',value:'682',status:"error",unit:'rpm'},
          {name:'运行电流',value:'47.2',status:"error",unit:'A'},
          {name:'驱动端轴承温度',value:'58.1',status:"error",unit:'℃'},
          {name:'工作液入口温度',value:'35.6',status:"error",unit:'℃'},
          {name:'非驱动端轴承振动',value:'2.3',status:"waring",unit:'mm/s'},
          {name:'驱动端轴承振动',value:'3.2',status:"waring",unit:'mm/s'},

        ],
        [
          {name:'电机扭矩',value:'29',status:"error",unit:'N·m'},
          {name:'X向电机振动',value:'-94.9',status:"waring",unit:'mm/s'},
          {name:'Y向电机振动',value:'35.7',status:"normal",unit:'mm/s'},
          {name:'X向泵振动',value:'25.6',status:"normal",unit:'mm/s'},
          {name:'Y向泵振动',value:'23.1',status:"normal",unit:'mm/s'},
          {name:'冷却水温度',value:'13.3',status:"normal",unit:'℃'},
        ],
        [
          {name:'运行转速',value:'12660',status:"error",unit:'rpm'},
          {name:'出口孔板',value:'87',status:"error",unit:'°C'},
          {name:'入口压力',value:'993',status:"normal",unit:'mabrA'},
          {name:'出口压力',value:'710',status:"normal",unit:'mabrG'},
          {name:'孔板压力',value:'680',status:"normal",unit:'mabrG'},
          {name:'压差',value:'50.2',status:"normal",unit:'mbar'},
        ]
      ],
      dataLiat:[]
    };
  },
  mounted() {

  },
  watch: {
    "$i18n.locale": {
      handler() {
        this.initChart();
      },
      deep: true
    },
    measurements_list:{
      handler(newVal) {
        if(newVal){
          let list = _.cloneDeep(newVal),
              reslut = [];
          list.forEach(item=>{
            /* item.stat  未知-1  健康0  异常1  危险2 */ 
            reslut.push({
              name:item.name,
              data:[{ name:item.name, value:3 }]   //value来决定大小气泡的大小，测点更新频率问题暂时写死。
            })
          })
          this.dataLiat = reslut
          this.initChart();
        }
      },
      immediate: true,
      deep:true
    }
  },
  computed:{

  },
  methods: {
    // 通过value的大小控制气泡的大小(3,6 随机加上数,控制气泡大小的,成大小关系)
    handleStatValue(stat){
      let value = 0
      if(stat == 0){
        value = stat
      }else if(stat == 1){
        value = Number(stat) + 3
      }else if(stat == 2){
        value = Number(stat) + 6
      }else{
        value = stat
      }
      return value;
    },
    randomNumber(min, max) {
      return Math.random() * (max - min) + min;
    },
    initChart() {

        let options = {
          series: this.dataLiat,
          colors: [
            "#83C9CD",
            "#00CED1",
            "#4597CB",
            "#048A7F",
            "#3162B0",
            "#87CEFA",
            "#D2D3D2",
            "#13C1CD",
            "#20CED9",
            "#3197CB",
            "#441A7F",
            "#5112B0",
            "#61CEFA",
            "#72D9D2",
            "#83C1CD",
            "#90CED9",
            "#1197CB",
            "#228A7F",
            "#3362B0",
            "#44CEFA",
            "#55D3D2"
          ],
          filterValue: 0+3,
          domDiv: document.querySelector("#pocked")
        };
      this.$nextTick(()=>{
        PackedChart(options);
      })

    }
  },
  components: {}
};
</script>

<style scoped lang="scss">
.model,
#pocked {
  width: 100%;
  height: 100%;
}
</style>
